// import Swiper JS
import Swiper from 'swiper';
// import Swiper styles
import 'swiper/css';

class ProductCarousel {
    constructor(rootElement) {
        this.prev = rootElement.querySelector('.prev');
        this.next = rootElement.querySelector('.next');
        this.swiper = new Swiper(rootElement.querySelector('.swiper'), {
            slidesPerView: 'auto',
            spaceBetween: 0,
            breakpoints: {
                1025: {
                    spaceBetween: 30,
                },
            },
        });

        this.prev?.addEventListener('click', this.onPreviousClick.bind(this));
        this.next?.addEventListener('click', this.onNextClick.bind(this));
        this.swiper.on('activeIndexChange', this.onIndexChange.bind(this));

        if (window.outerWidth < 1025) {
            this.swiper.disable();
        }
    }

    onPreviousClick() {
        this.swiper.slidePrev();
    }

    onNextClick() {
        this.swiper.slideNext();
    }

    enableButton(button) {
        button.removeAttribute('disabled');
    }

    disableButton(button) {
        button.setAttribute('disabled', true);
    }

    onIndexChange() {
        if (this.swiper.isBeginning) {
            this.disableButton(this.prev);
        } else {
            this.enableButton(this.prev);
        }
        if (this.swiper.isEnd) {
            this.disableButton(this.next);
        } else {
            this.enableButton(this.next);
        }
    }
}

const carousels = document.querySelectorAll('.product-carousel__swiper');
if (carousels) {
    carousels.forEach(el => {
        new ProductCarousel(el);
    });
}
